import type { Author } from '@/types/microcms/author'
import type { Column } from '@/types/microcms/column'

/** 著者が未設定の記事で、日付の横に出す名前 */
export const DEFAULT_COLUMN_AUTHOR = 'LAWGUE編集部'

/** 公開日。上書き（overwriteCreatedAt）を優先する（旧実装を踏襲） */
export const getColumnDate = (
  column: Pick<Column, 'overwriteCreatedAt' | 'publishedAt' | 'createdAt'>
) => column.overwriteCreatedAt || column.publishedAt || column.createdAt

/** 記事の著者。authors は単一参照と複数参照のどちらの形でも入りうるので先頭を返す */
export const getColumnAuthor = (
  column: Pick<Column, 'authors'>
): Author | undefined =>
  Array.isArray(column.authors) ? column.authors[0] : column.authors
